var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 64V448C0 483.25 28.75 512 64 512H320C355.25 512 384 483.25 384 448V128L256 0H64C28.75 0 0 28.75 0 64ZM224 256H160V192H224V256ZM320 256H256V192H288C305.75 192 320 206.25 320 224V256ZM256 384H320V416C320 433.75 305.75 448 288 448H256V384ZM160 384H224V448H160V384ZM64 384H128V448H96C78.25 448 64 433.75 64 416V384ZM64 288H320V352H64V288ZM64 224C64 206.25 78.25 192 96 192H128V256H64V224Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimCard);
export default __webpack_public_path__ + "static/media/sim-card.134d4b90a4c5cadd0c4bf9cb3051aac5.svg";
export { ForwardRef as ReactComponent };